// extracted by mini-css-extract-plugin
export default {"root":"MultipleSelect_root__f2Rb7","disabled":"MultipleSelect_disabled__TLnd1"};